import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import HeaderTwo from "../components/common/headerTwo";
import Footer from "../components/common/footer";

import SinglePostHero from '../components/knowledge/hero_single';
import { postsData } from '../data/postData';


function SinglePost() {
  const { slug } = useParams();
  const post = postsData.find((p) => p.slug === slug);


  if (!post) {
    return (
      <>
        <HeaderTwo />
        <main className="relative z-40 min-h-[50vh] flex flex-col items-center justify-center">
          <h1 className="text-4xl font-bold color-green">Błąd 404</h1>
          <p className="text-gray-600 mt-4">Nie znaleziono takiego wpisu.</p>
          <Link to="/baza-wiedzy" className="mt-6 button-green">Wróć do bazy wiedzy</Link>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
      
        <title>{post.title} | Drzewus</title>
        <meta name="title" content={`${post.title} | Drzewus`} />
        <meta name="description" content={post.excerpt} key="desc" />
        <meta property="og:title" content={`${post.title} | Drzewus`} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:image" content={post.imageUrl} />
      </Helmet>
      
      <HeaderTwo />
      
      <main className="relative z-40">
        <SinglePostHero 
  title={post.title} 
  date={post.date} 
  imageUrl={post.imageUrl} 
/>
        
        {/* Kontener z treścią wpisu */}
        <article className="p-6 lg:px-24 lg:py-16 max-w-4xl mx-auto">
          <Link to="/baza-wiedzy" className="text-gray-500 hover:text-green-600 mb-8 inline-flex items-center gap-2 transition-colors font-semibold">
            &larr; Wróć do listy wpisów
          </Link>
          
          <h2 className="text-3xl lg:text-5xl font-bold color-green mb-10 leading-tight">
            {post.title}
          </h2>
          
          {/* whitespace-pre-wrap zachowuje entery/nowe linie z Twojego tekstu */}
          <div className="text-lg text-gray-700 leading-relaxed whitespace-pre-wrap">
            {post.content}
          </div>
        </article>
      </main>
      
      <Footer />
    </>
  );
}

export default SinglePost;